import React, {useState, useEffect} from "react";
import { Link, useNavigate } from 'react-router-dom'
import { dashboardApproveUrl } from "../../apis/urls";
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 
import { FallingLines } from 'react-loader-spinner'


const DashBoard = () => {


    useEffect( ()=> {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        ApproveListing();
    },[])

    let navigate = useNavigate()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)




    const [result, setResult] = useState([]);   
    const [loader, setLoader] = useState(true);  


    let token = "Bearer "+localStorage.getItem('token');

    const ApproveListing = () => {
         
        const instance = axios.create({

            baseURL: dashboardApproveUrl,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data);
            setLoader(false)

            console.log(response.data.data)
          }).catch((error) =>{
            
            localStorage.removeItem('token')
    
            navigate("/")

            console.log('error',error.message)
            
          });

    }


    let sl=1;
    let arr =0;

    return( 
        <div className="dashboard">
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div>

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Dashboard - Pending by GIAA  </h2>
                        </div>
                    </div>


                        {!loader?
                        <div class="container">


                            <table class="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                    <th scope="col">Sl.No</th>
                                    <th scope="col">School Name</th>
                                    <th scope="col">Pending by GIAA</th>
                                    <th scope="col" style={{textAlign:'center'}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                {
                                        
                                    result?.map((item,index) =>(

                                        <tr>
                                            <td>{sl++}</td>
                                            <td>{decode(item.schoolName)}</td>
                                            <td><Link  to={"/giaa_dashboard/"+arr++} style={{color:'#000'}} data-toggle="tooltip" title="Athletic Eligibility">{item.count}</Link></td>
                                            <td>
                                                <div className="list-action-wrpr showicons roundicons-text">
                                                    <div className="list-action-wrpr">
                                                    <Link  to={"/school_list/athlet_list/"+item.id} data-toggle="tooltip" title="View">
                                                        <i class="view icon-eye"></i>
                                                        <span>View All</span>
                                                    </Link>
                                                    </div>
                                                </div>
                                            </td>
                                        
                                        </tr>
                                    ))
                                }
                                
                                </tbody>
                            </table>
                        </div>:


                        <div class="container" style={{alignItems:'center', marginLeft:'45%', marginTop:'20%'}}>
                    <div className="fp-container">
                        <FallingLines
                            color="#fff"
                            width="50"
                            visible={true}
                            ariaLabel='falling-lines-loading'
                            />
                    </div>
                    </div>
                    }

                    </div>
                </div>
            </aside>
        </div>
    )
};

export default DashBoard;
